// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
    width: 100%;
    display: grid;
    grid-template-columns: 228px 1fr;
    padding-left: 200px;
    padding-right: 200px;
    padding-top: 20px;
    padding-bottom: 20px;
    gap: 10px;
    margin: 0 auto;
}

.sitebar {
    display: flex;
    background-color: #f7f7f7;
    align-items: center;
    justify-content: start;
    flex-direction: column;
}

.sitebar__title {
    width: 100%;
    display: flex;
    padding: 5px;
    align-items: center;
    justify-content: center;
    background-color: #AF2C30;
}

.sitebar__title p {
    font-size: 16px;
    line-height: 1.3em;
    text-align: center;
    color: #EEF1E5;
}

.sitebar__filter {
    width: 100%;
    margin-top: 20px;
    padding: 0px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
}

.sitebar__filter-inp {
    width: 100%;
    display: flex;
    align-items: start;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
}

.content {
    width: 100%;
    background-color: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: start;
    flex-direction: column;
    padding: 20px;
    gap: 20px;
}

.content__filter {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: left;
    gap: 20px;
}

.content__filter p {
    font-size: 13px;
    cursor: pointer;
    color: rgb(51, 51, 51);
    line-height: 1.3em;
    text-decoration: underline;
}

.content__cards {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    min-height: 416px;
}

.content__card {
    width: 100%;
    height: 198px;
    display: flex;
    align-items: center;
    justify-content: start;
    flex-direction: column;
    background-color: #FFF;
}

.content__card-number {
    width: 100%;
    min-height: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(77, 77, 77);
    color: #EEF1E5;
}

.content__card-number p {
    font-size: 11px;
    line-height: 1.3em;
    text-decoration: underline;
}

.content__card-desc {
    width: 100%;
    padding: 10px 20px;
    gap: 2px;
    display: flex;
    align-items: start;
    justify-content: center;
    flex-direction: column;
}

.content__card-desc p {
    font-size: 11px;
    line-height: 1.3em;
    color: rgb(51, 51, 51);
}

.content__card-desc p span {
    font-weight: 700;
}

.content__title{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: left;
}

.content__title p{
    font-size: 25px;
    line-height: 1.3em;
    font-weight: bold;
    color: rgb(51,51,51);
    letter-spacing: 0.01em;
}


.act {
    width: 100%;
    display: flex;
    align-items: start;
    justify-content: center;
    flex-direction: column;
    gap: 5px;
}
.act h1 {
    font-size: 24px;
    margin-bottom: 20px;
}
.act p {
    font-weight: bold;
    color: rgb(51,51,51);
    letter-spacing: 0.05em;
    font-size: 10px;
}
.act .label {
    font-weight: 500;
}
.sitebar__filter-btn{
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
}

.content__images{
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    flex-wrap: wrap;
}

.content__images img{
    width: 100%;
}

.pagination{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}
.pagination button{
    background-color: #00000000;
    border: none;
    cursor: pointer;
    font-size: 12px;
}

@media(max-width:991px) {
    .home {
        padding-left: 50px;
        padding-right: 50px;
    }
}

@media(max-width: 750px) {
    .home {
        padding-left: 15px;
        padding-right: 15px;
    }

    .content__cards {
        grid-template-columns: 1fr;
    }
    .content{
        padding: 10px !important;
    }
}

@media(max-width:550px) {
    .home {
        display: flex;
        flex-direction: column;
        padding-top: 0px;
    }

    .content__cards {
        grid-template-columns: 1fr 1fr;
    }
    .sitebar__filter-btn{
        grid-template-columns: 1fr;
        gap: 10px;
    }
}

@media(max-width:450px){
    .content__cards {
        grid-template-columns: 1fr;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/style/home.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;IACpB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;AAC1B;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;AACA;IACI,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;IACA;QACI,0BAA0B;QAC1B,SAAS;IACb;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".home {\r\n    width: 100%;\r\n    display: grid;\r\n    grid-template-columns: 228px 1fr;\r\n    padding-left: 200px;\r\n    padding-right: 200px;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.sitebar {\r\n    display: flex;\r\n    background-color: #f7f7f7;\r\n    align-items: center;\r\n    justify-content: start;\r\n    flex-direction: column;\r\n}\r\n\r\n.sitebar__title {\r\n    width: 100%;\r\n    display: flex;\r\n    padding: 5px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #AF2C30;\r\n}\r\n\r\n.sitebar__title p {\r\n    font-size: 16px;\r\n    line-height: 1.3em;\r\n    text-align: center;\r\n    color: #EEF1E5;\r\n}\r\n\r\n.sitebar__filter {\r\n    width: 100%;\r\n    margin-top: 20px;\r\n    padding: 0px 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.sitebar__filter-inp {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: start;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.content {\r\n    width: 100%;\r\n    background-color: #f7f7f7;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: start;\r\n    flex-direction: column;\r\n    padding: 20px;\r\n    gap: 20px;\r\n}\r\n\r\n.content__filter {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: left;\r\n    gap: 20px;\r\n}\r\n\r\n.content__filter p {\r\n    font-size: 13px;\r\n    cursor: pointer;\r\n    color: rgb(51, 51, 51);\r\n    line-height: 1.3em;\r\n    text-decoration: underline;\r\n}\r\n\r\n.content__cards {\r\n    width: 100%;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n    gap: 20px;\r\n    min-height: 416px;\r\n}\r\n\r\n.content__card {\r\n    width: 100%;\r\n    height: 198px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: start;\r\n    flex-direction: column;\r\n    background-color: #FFF;\r\n}\r\n\r\n.content__card-number {\r\n    width: 100%;\r\n    min-height: 17px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgb(77, 77, 77);\r\n    color: #EEF1E5;\r\n}\r\n\r\n.content__card-number p {\r\n    font-size: 11px;\r\n    line-height: 1.3em;\r\n    text-decoration: underline;\r\n}\r\n\r\n.content__card-desc {\r\n    width: 100%;\r\n    padding: 10px 20px;\r\n    gap: 2px;\r\n    display: flex;\r\n    align-items: start;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.content__card-desc p {\r\n    font-size: 11px;\r\n    line-height: 1.3em;\r\n    color: rgb(51, 51, 51);\r\n}\r\n\r\n.content__card-desc p span {\r\n    font-weight: 700;\r\n}\r\n\r\n.content__title{\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: left;\r\n}\r\n\r\n.content__title p{\r\n    font-size: 25px;\r\n    line-height: 1.3em;\r\n    font-weight: bold;\r\n    color: rgb(51,51,51);\r\n    letter-spacing: 0.01em;\r\n}\r\n\r\n\r\n.act {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: start;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    gap: 5px;\r\n}\r\n.act h1 {\r\n    font-size: 24px;\r\n    margin-bottom: 20px;\r\n}\r\n.act p {\r\n    font-weight: bold;\r\n    color: rgb(51,51,51);\r\n    letter-spacing: 0.05em;\r\n    font-size: 10px;\r\n}\r\n.act .label {\r\n    font-weight: 500;\r\n}\r\n.sitebar__filter-btn{\r\n    width: 100%;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n    gap: 20px;\r\n}\r\n\r\n.content__images{\r\n    width: 100%;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n    gap: 20px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.content__images img{\r\n    width: 100%;\r\n}\r\n\r\n.pagination{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 5px;\r\n}\r\n.pagination button{\r\n    background-color: #00000000;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n}\r\n\r\n@media(max-width:991px) {\r\n    .home {\r\n        padding-left: 50px;\r\n        padding-right: 50px;\r\n    }\r\n}\r\n\r\n@media(max-width: 750px) {\r\n    .home {\r\n        padding-left: 15px;\r\n        padding-right: 15px;\r\n    }\r\n\r\n    .content__cards {\r\n        grid-template-columns: 1fr;\r\n    }\r\n    .content{\r\n        padding: 10px !important;\r\n    }\r\n}\r\n\r\n@media(max-width:550px) {\r\n    .home {\r\n        display: flex;\r\n        flex-direction: column;\r\n        padding-top: 0px;\r\n    }\r\n\r\n    .content__cards {\r\n        grid-template-columns: 1fr 1fr;\r\n    }\r\n    .sitebar__filter-btn{\r\n        grid-template-columns: 1fr;\r\n        gap: 10px;\r\n    }\r\n}\r\n\r\n@media(max-width:450px){\r\n    .content__cards {\r\n        grid-template-columns: 1fr;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
